import React, { Component } from 'react';
import 'react-tooltip/dist/react-tooltip.css'
import { Pie} from 'react-chartjs-2';
import {Chart, ArcElement} from 'chart.js'
import { BsBorderWidth } from 'react-icons/bs';
import { MdBorderColor } from 'react-icons/md';
Chart.register(ArcElement);

class SmplePie extends Component {
    constructor(props){
        super(props);
        this.percent = props.percent;
      }
    getData(){
        return {
            datasets: [
              {
                data: [this.percent, 100-this.percent],
                backgroundColor: ['#584DAE', '#DEDAFB'],
                borderWidth:0,
              }
            ]
          };        
    }
    render () {
        const data = this.getData();
        return (
            <Pie data={data} />
      );
    }
  }

export default SmplePie;